import React from 'react';

const DateTimeInput = ({ label, id, name, value, onChange, error, className = "col-md-6" }) => {
    const formatValue = (rawValue) => {
        if (!rawValue) return { date: '', time: '' };
        const dateObj = new Date(rawValue);
        if (isNaN(dateObj)) return { date: '', time: '' };
        
        const date = dateObj.toISOString().split('T')[0];
        const time = dateObj.toTimeString().slice(0, 8);
        return { date, time };
    };

    const { date, time } = formatValue(value);

    const handleChange = (type, newValue) => {
        if (!date && !time) {
            const now = new Date();
            if (type === 'date') {
                const [year, month, day] = newValue.split('-');
                now.setFullYear(parseInt(year), parseInt(month) - 1, parseInt(day));
            } else {
                const [hours, minutes, seconds] = newValue.split(':');
                now.setHours(parseInt(hours), parseInt(minutes), parseInt(seconds));
            }
            onChange({
                target: {
                    name,
                    value: now.toISOString().slice(0, 19).replace('T', ' ')
                }
            });
        } else {
            const currentDate = date || new Date().toISOString().split('T')[0];
            const currentTime = time || '00:00:00';
            
            const finalValue = type === 'date' 
                ? `${newValue} ${currentTime}`
                : `${currentDate} ${newValue}`;
                
            onChange({
                target: {
                    name,
                    value: finalValue
                }
            });
        }
    };

    return (
        <div className="col-md-2">
            <label htmlFor={id} className="form-label">
                {label}
            </label>
            <div className="d-flex gap-2 flex-wrap">
                <input
                    type="date"
                    className={`form-control ${error && error.length > 0 ? 'is-invalid' : ''}`}
                    id={`${id}-date`}
                    value={date}
                    onChange={(e) => handleChange('date', e.target.value)}
                />
                {/* <input
                    type="time"
                    className={`form-control ${error && error.length > 0 ? 'is-invalid' : ''}`}
                    id={`${id}-time`}
                    value={time}
                    onChange={(e) => handleChange('time', e.target.value)}
                    step="1"
                /> */}
            </div>
            {error && error.length > 0 && (
                <div className="invalid-feedback d-block">{error.join(', ')}</div>
            )}
        </div>
    );
};

export default React.memo(DateTimeInput);